import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new  Vuex.Store({
    state: {
      query: window.search_text !== undefined ? window.search_text : '',
      search_link: window.search_link !== undefined ? window.search_link : '',
      selectedResources: null,
      totalResources: window.total !== undefined ? window.total : 0,
      resources: window.resources !== undefined ? window.resources : [],
      types: window.options.types,
      activeTypes: window.activeFilters != undefined ? window.activeFilters.types : [],
      classifications: window.options.classifications,
      activeClassifications: window.activeFilters  != undefined ? window.activeFilters.classifications : [],
      targets: window.options.targets,
      activeTargets: window.activeFilters != undefined ? window.activeFilters.targets : [],
      languages: window.options.languages,
      activeLanguages: window.activeFilters != undefined ? window.activeFilters.languages : [],
      fluencies: window.options.fluencies,
      activeFluencies: window.activeFilters != undefined ? window.activeFilters.fluencies : [],
      routeHistory: 1,
    },
    mutations: {
      resetRouteHistory(state, item) {
        state.routeHistory = 1;
      },
      incrementRouteHistory(state, item) {
        state.routeHistory++;
      },
      setSelectedResource (state, item) {
        state.selectedResources = item
      },
      updateActiveTypes (state, items) {
        state.activeTypes = items
      },
      removeActiveType (state, index) {
        state.activeTypes.splice(index, 1);
      },
      
      updateActiveClassifications (state, items) {
        state.activeClassifications = items
      },
      removeActiveClassification (state, index) {
        state.activeClassifications.splice(index, 1);
      },
      
      updateActiveTargets (state, items) {
        state.activeTargets = items
      },
      removeActiveTarget (state, index) {
        state.activeTargets.splice(index, 1);
      },
      
      updateActiveLanguages (state, items) {
        state.activeLanguages = items
      },
      removeActiveLanguage (state, index) {
        state.activeLanguages.splice(index, 1);
      },
      
      updateActiveFluencies (state, items) {
        state.activeFluencies = items
      },
      removeActiveFluency (state, index) {
        state.activeFluencies.splice(index, 1);
      },
      setResource (state, items) {
        state.resources.push(...items)
      },
      setQuery (state, value) {
        state.query = value
      }
    },
    actions: {
      search ({ commit, state }, items) {
        // // save the items currently in the cart
        // const savedCartItems = [...state.cart.added]
        // // send out checkout request, and optimistically
        // // clear the cart
        // commit(types.CHECKOUT_REQUEST)
        // // the shop API accepts a success callback and a failure callback
        // shop.buyProducts(
        //   products,
        //   // handle success
        //   () => commit(types.CHECKOUT_SUCCESS),
        //   // handle failure
        //   () => commit(types.CHECKOUT_FAILURE, savedCartItems)
        // )
        // axios.get(`/resources/getData?start=${page}`, {}).then(({ data }) => {
        //   commit('setResource', data)
        // });

        commit('setResource', items)
      }
    },

    getters : {
      actionURL: (state, getters) => {
        let str = "";
        if (state.query !== "") {
          str = `text=${encodeURIComponent(state.query)}`
        }
        
        if (state.activeTypes.length > 0 ) {
          if (str != "") {
            str += "&"
          }
          str += state.activeTypes.map(function(item){return `types[]=${encodeURIComponent(item.name)}`;}).join("&");
        }

        if (state.activeClassifications.length > 0 ) {
            if (str != "") {
              str += "&"
            }
            str += state.activeClassifications.map(function(item){return `classifications[]=${encodeURIComponent(item.name)}`;}).join("&");
        }

        if (state.activeTargets.length > 0 ) {
            if (str != "") {
              str += "&"
            }
            str += state.activeTargets.map(function(item){return `targets[]=${encodeURIComponent(item.name)}`;}).join("&");
        }

        if (state.activeLanguages.length > 0 ) {
            if (str != "") {
              str += "&"
            }
            str += state.activeLanguages.map(function(item){return `languages[]=${encodeURIComponent(item.name)}`;}).join("&");
        }
        if (state.activeFluencies.length > 0 ) {
            if (str != "") {
              str += "&"
            }
            str += state.activeFluencies.map(function(item){return `fluencies[]=${encodeURIComponent(item.name)}`;}).join("&");
        }
        
        if (str !== "") {
          return state.search_link + '?' + str;
        }
        return state.search_link;
      }
    }
})